import moment from 'moment';

export const formatAsMinutesSeconds = (timestamp) =>
  moment(moment.duration(timestamp / 1000, 'seconds').asMilliseconds()).format(
    'mm:ss'
  );

export default { formatAsMinutesSeconds };
